import React, { useState, useRef, useEffect } from "react";
import { Globe, ChevronDown, Check } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { LANGUAGES } from "../i18n/translations";

export const LanguageSwitcher = ({ isLight }) => {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="language-switcher-button"
        onClick={() => setOpen((o) => !o)}
        className={`flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider px-2.5 py-2 rounded-md border transition-colors ${isLight ? "border-black/10 text-neutral-700 hover:border-black/30" : "border-white/10 text-neutral-300 hover:border-white/30"}`}
        aria-label="Change language"
      >
        <Globe className="w-3.5 h-3.5" />
        <span className="hidden sm:inline">{current.code.toUpperCase()}</span>
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div
          data-testid="language-switcher-menu"
          className={`absolute right-0 mt-2 w-44 rounded-lg border shadow-2xl overflow-hidden z-[60] ${isLight ? "bg-white border-black/10" : "bg-[#12141c] border-white/10"}`}
        >
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              data-testid={`language-option-${l.code}`}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full flex items-center gap-2.5 px-3 py-2.5 text-sm text-left transition-colors ${isLight ? "hover:bg-black/5 text-neutral-800" : "hover:bg-white/5 text-neutral-200"}`}
            >
              <span className="text-base leading-none">{l.flag}</span>
              <span className="flex-1">{l.label}</span>
              {l.code === lang && <Check className="w-3.5 h-3.5 text-[#A67C52]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
